import { render, staticRenderFns } from "./OccupationList.vue?vue&type=template&id=eed15b10&"
import script from "./OccupationList.vue?vue&type=script&lang=js&"
export * from "./OccupationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports